import { Dispatch, SetStateAction, useState } from 'react';
import { useArchiveProfile } from 'api';
import { ReasonToArchive } from 'api/archive/archiveApiTypes';

type UseProfileArchiveProps = {
  learnerId: string;
  profileId: string;
  organisationId: string;
};

interface UseProfileArchiveReturn {
  showArchiveDialog: boolean;
  setShowArchiveDialog: (show: boolean) => void;
  archiveError: boolean;
  archiveReason: ReasonToArchive;
  setArchiveReason: Dispatch<SetStateAction<ReasonToArchive>>;
  archiveReasonOther: string;
  setArchiveReasonOther: Dispatch<SetStateAction<string>>;
  handleArchiveProfile: () => void;
  handleProfileArchiveClose: () => void;
}

export const useProfileArchive = ({
  learnerId,
  profileId,
  organisationId,
}: UseProfileArchiveProps): UseProfileArchiveReturn => {
  const [showArchiveDialog, setShowArchiveDialog] = useState(false);
  const [archiveError, setArchiveError] = useState(false);
  const [archiveReason, setArchiveReason] = useState<ReasonToArchive>('');
  const [archiveReasonOther, setArchiveReasonOther] = useState<string>('');

  const { mutate: archiveProfile } = useArchiveProfile(
    learnerId,
    organisationId,
  );

  const handleArchiveProfile = () => {
    archiveProfile(
      {
        profileId,
        organisationId,
        archiveReason,
        ...(archiveReason === 'OTHER' && { reasonOther: archiveReasonOther }),
      },
      {
        onSuccess: () => {
          setShowArchiveDialog(false);
          setArchiveError(false);
        },
        onError: () => {
          setArchiveError(true);
        },
      },
    );
  };

  const handleProfileArchiveClose = () => {
    setShowArchiveDialog(false);
    setArchiveError(false);
  };

  return {
    showArchiveDialog,
    setShowArchiveDialog,
    archiveError,
    archiveReason,
    setArchiveReason,
    archiveReasonOther,
    setArchiveReasonOther,
    handleArchiveProfile,
    handleProfileArchiveClose,
  };
};
